export default "__VITE_ASSET__CmB3kO86__"